export default __webpack_public_path__ + "static/cadre_suspendu-c8a603e620d9a7a32ed4b38e4ca94522.png";